import settings from './settings'
import thesauri from './thesauri'

export default
{
    settings,
    thesauri
};
